// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"478":"organization","594":"about","778":"people"}[chunkId] + "." + {"478":"2bbac645","594":"eae81073","778":"0fc4c8ff"}[chunkId] + ".js";
};